<ibp-card [title]="notification.title"  class="card d-flex justify-content-center" [id]="notification.id">
  <p ibpCardContent [innerHTML]="notification.description"></p>
</ibp-card>
